/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
import { DISPATCH_HOLDINGS_API_START } from 'actionTypes/other';
import TRADE, { TRADE_CONSTANTS } from 'actionTypes/trade';
import USER, { UNAUTHORIZED } from 'actionTypes/user';
import WALLET, { BALANCES_FAIL_ABORTED } from 'actionTypes/wallet';
import { getAllContractsData } from 'components/holdings/helper';
import { ORDER_CATEGORY } from 'constants/enums';
import { getProductByIDHelper } from 'epics/alerts';
import {
  pipe,
  find,
  propEq,
  prop,
  map,
  filter,
  keys,
  findIndex,
  path,
  forEach,
  update,
  merge,
  remove,
  mergeDeepRight,
  uniqWith,
  eqBy,
  sort,
  evolve,
  values,
  flatten,
  includes,
  toPairs,
} from 'helpers/ramda';
import {
  getContractType,
  contractsObject,
  isFutures,
  isTurbo,
  isCallPutOptions,
  isOptionCombos,
  noop,
} from 'helpers/utils';
import i18n from 'i18n/config';
import { ContractType } from 'types/IProducts';

import { PRIVATE_SOCKET_ACTIONS } from './helpers/trade';
// import { updateOrderbook } from 'actions/trade';

// import { initialState as openOrdersState } from './openOrders';
// import tradeState from './initialstate/trade';

// const productTypeV2 = {
//   future: 'vanilla',
//   inverse_future: 'inverse',
// };

const orderCategoryIdMap = {
  [ORDER_CATEGORY.OPEN_ORDER]: 'open-orders',
  [ORDER_CATEGORY.STOP_ORDER]: 'stop-orders',
};

const orderCategorySlugMap = {
  [ORDER_CATEGORY.OPEN_ORDER]: 'openOrders',
  [ORDER_CATEGORY.STOP_ORDER]: 'openStopOrders',
};

const tabList = [
  {
    label: i18n.t('trading:holdingsTabList.openPositions'),
    id: 'open-positions',
    selectValue: 'open-positions',
  },
  {
    label: i18n.t('trading:holdingsTabList.openOrders'),
    id: 'open-orders',
    selectValue: 'open-orders',
  },
  {
    label: i18n.t('trading:holdingsTabList.stopOrders'),
    id: 'stop-orders',
    selectValue: 'stop-orders',
  },
  {
    label: i18n.t('trading:holdingsTabList.trackerAssets'),
    id: 'smart-holdings',
    selectValue: 'smart-holdings',
  },
  {
    label: i18n.t('trading:holdingsTabList.balance'),
    id: 'balance',
    selectValue: 'balance',
  },
  {
    label: i18n.t('trading:holdingsTabList.fills'),
    id: 'fills',
    selectValue: 'fills',
  },
  {
    label: i18n.t('trading:holdingsTabList.orderHistory'),
    id: 'orders-history',
    selectValue: 'orders-history',
  },
];

const tabListMobile = [
  {
    label: i18n.t('trading:holdingsTabList.openPositions'),
    id: 'openPositions',
  },
  {
    label: i18n.t('trading:holdingsTabList.openOrders'),
    id: 'openOrders',
  },
  {
    label: i18n.t('trading:holdingsTabList.conditionalOrders'),
    id: 'stopOrders',
  },
  {
    label: i18n.t('trading:holdingsTabList.fills'),
    id: 'fills',
  },
  {
    label: i18n.t('trading:holdingsTabList.orderHistory'),
    id: 'orderHistory',
  },
];

const initialState = {
  desktop: tabList,
  mobile: tabListMobile,
  openPositions: contractsObject(),
  openOrders: contractsObject(),
  openStopOrders: contractsObject(),
  bracketOrders: {},
  selectedContractType: 'all',
  holdingsFilterType: 'dropdown',
  mobileHoldingsContractType: 'all',
  loading: {
    openPositions: true,
    // Below are false as we never know whether we have orders or not
    openOrders: false,
    openStopOrders: false,
  },
  products: {},
  lastStatus: {
    isUserTriggered: false,
    pendingCount: 0,
    refreshId: null,
  },
};

// Deprecated this function, not required anymore. Test before removing
const updateOpenOrdersLabel = (id, count) =>
  map(tab => {
    if (id.includes(tab.id)) {
      const countLabel = count > 0 ? `[${count}]` : '';
      const label = pipe(find(propEq('id', tab.id)), prop('label'))(tabList);
      return {
        ...tab,
        label: `${label} ${countLabel}`,
      };
    }
    return tab;
  });

const filterOrdersFromApi = orders => {
  const {
    all,
    futures,
    options,
    spreads,
    interest_rate_swaps,
    spot,
    turbo_options,
    options_combos,
    tracker,
    move_options,
  } = contractsObject();
  all.data = orders;
  futures.data = filter(order => isFutures(order.product.contract_type), orders);
  options.data = filter(order => isCallPutOptions(order.product.contract_type), orders);
  move_options.data = filter(
    order => order.product.contract_type === ContractType.MoveOptions,
    orders
  );
  spot.data = filter(order => order.product.contract_type === 'spot', orders);
  interest_rate_swaps.data = filter(
    order => order.product.contract_type === 'interest_rate_swaps',
    orders
  );
  spreads.data = filter(
    order =>
      order.product.contract_type === 'interest_rate_swaps' ||
      order.product.contract_type === 'spreads',
    orders
  );
  turbo_options.data = filter(order => isTurbo(order.product.contract_type), orders);
  options_combos.data = filter(
    order => isOptionCombos(order.product.contract_type),
    orders
  );
  tracker.data = filter(order => order.product.contract_type === 'tracker', orders);
  return {
    all,
    futures,
    options,
    spot,
    interest_rate_swaps,
    spreads,
    turbo_options,
    tracker,
    move_options,
  };
};

const getCount = (state, contractType, data, allContracts, slug) => {
  if (state.selectedContractType === contractType) {
    return data.length;
  }

  if (state.selectedContractType === 'all') {
    return allContracts.data.length;
  }

  return state[slug][state.selectedContractType].data.length;
};

const getEvolveState = (state, id, count) => {
  return evolve(
    {
      desktop: updateOpenOrdersLabel(id, count),
    },
    state
  );
};

const updateStateObj = (slug, state, data, evolveState) => {
  return slug
    ? {
        ...evolveState,
        [slug]: data,
        loading: {
          ...state.loading,
          [slug]: false,
        },
      }
    : { ...evolveState };
};

const getOrders = (data, state, id, slug) => {
  const contractType = getContractType(path([0, 'product', 'contract_type'], data));

  const allOrders = getAllContractsData(
    {
      ...state[slug],
      [contractType]: {
        data,
      },
      all: {
        data: [],
      },
    },
    slug
  );

  const newOrders = {
    ...state[slug],
    [contractType]: {
      data,
    },
    all: allOrders,
  };

  const count = getCount(state, contractType, data, allOrders, slug);
  const evolveState = getEvolveState(state, id, count);
  return updateStateObj(slug, state, newOrders, evolveState);
};

const getIndex = (dataArray, newObj, slug) => {
  let pindex = -1;
  dataArray.forEach((obj, index) => {
    if (
      (slug === 'openPositions' && obj.product.id === newObj.product_id) ||
      (slug !== 'openPositions' && obj.id === newObj.id)
    ) {
      pindex = index;
    }
  });
  return pindex;
};

const resetBracketOrderObj = obj => ({
  limit_price: null,
  stop_price: null,
  trail_amount: null,
  id: obj.id,
});

const sortOrdersByCreatedAt = data =>
  sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
    uniqWith(eqBy(prop('id')))(data)
  );

const updateOrderObj = (data, state, id, slug) => {
  const positionActionType = data.action;
  const contractType = getContractType(data.product?.contract_type);
  let orders = state[slug][contractType].data;
  // if slug is "openPositions" and contractType is "tracker", then dont add to allOrders
  let allOrders = state[slug].all.data;

  let pindex;
  let indexInAll;
  const skipTrackersinAllOrders = slug === 'openPositions' && contractType === 'tracker';

  if (positionActionType !== PRIVATE_SOCKET_ACTIONS.CREATE) {
    pindex = getIndex(orders, data, slug);
    indexInAll = getIndex(allOrders, data, slug);
    if (pindex === -1) {
      return {
        ...state,
      };
    }
  }

  const { take_profit_order, stop_loss_order } =
    state.bracketOrders[data.product.id] || {};
  data.bracket_orders = {};

  data.bracket_orders.take_profit_order = take_profit_order || resetBracketOrderObj({});
  data.bracket_orders.stop_loss_order = stop_loss_order || resetBracketOrderObj({});

  switch (positionActionType) {
    case PRIVATE_SOCKET_ACTIONS.CREATE:
      if (skipTrackersinAllOrders) {
        orders.unshift(data);
        break;
      } else {
        orders.unshift(data);
        allOrders.unshift(data);
      }
      break;
    case PRIVATE_SOCKET_ACTIONS.UPDATE:
      orders[pindex] = mergeDeepRight(orders[pindex], data);
      allOrders[indexInAll] = mergeDeepRight(allOrders[indexInAll], data);
      break;
    case PRIVATE_SOCKET_ACTIONS.DELETE:
      orders = remove(pindex, 1, orders);
      allOrders = skipTrackersinAllOrders ? allOrders : remove(indexInAll, 1, allOrders);
      break;
    default:
      break;
  }

  if (slug === 'openPositions') {
    orders = uniqWith(eqBy(prop('product_id')))(orders);
    allOrders = uniqWith(eqBy(prop('product_id')))(allOrders);
  } else {
    orders = sortOrdersByCreatedAt(orders);
    allOrders = sortOrdersByCreatedAt(allOrders);
  }

  const newOrders = {
    ...state[slug],
    [contractType]: {
      data: orders,
    },
    all: {
      data: allOrders,
    },
  };

  const count = state.selectedContractType === 'all' ? allOrders.length : orders.length;
  const evolveState = getEvolveState(state, id, count);
  return updateStateObj(slug, state, newOrders, evolveState);
};

const getBracketOrderObj = obj => ({
  limit_price: obj.limit_price,
  stop_price: obj.stop_price,
  trail_amount: obj.trail_amount,
  stop_trigger_method: obj.stop_trigger_method,
  id: obj.id,
});

const initBracketOrderObj = () => ({
  limit_price: null,
  stop_price: null,
  trail_amount: null,
  stop_trigger_method: null,
});

const getNewState = (state, data, bracketOrders, action) => {
  const contractType = getContractType(data[0].product.contract_type);
  const index = findIndex(propEq('product_id', data[0].product_id))(
    path(['openPositions', contractType, 'data'], state)
  );
  const indexAll = findIndex(propEq('product_id', data[0].product_id))(
    path(['openPositions', 'all', 'data'], state)
  );
  let finalState = {
    ...state,
    bracketOrders: { ...bracketOrders },
  };
  if (index !== -1) {
    const positionObj = path(['openPositions', contractType, 'data', index], state);
    const newBracketOrders = { ...positionObj.bracket_orders };
    data.forEach(obj => {
      newBracketOrders[obj.stop_order_type] =
        action === 'delete' ? initBracketOrderObj() : getBracketOrderObj(obj);
    });

    const newPositionObj = { ...positionObj, bracket_orders: newBracketOrders };
    const openPositions = {
      ...state.openPositions[contractType],
      data: update(index, newPositionObj, state.openPositions[contractType].data),
    };

    const allOpenPositions = state.openPositions.all;

    if (contractType !== 'tracker') {
      allOpenPositions.data = update(indexAll, newPositionObj, allOpenPositions.data);
    }

    finalState = merge(finalState, {
      openPositions: {
        ...state.openPositions,
        [contractType]: openPositions,
        all: allOpenPositions,
      },
    });
  }
  return finalState;
};

const updateLastStatus = (action, lastStatus) => {
  const { meta } = action;
  if (meta && lastStatus && meta.refreshId === lastStatus.refreshId) {
    const newPending = Math.max(0, lastStatus.pendingCount - 1);
    return {
      ...lastStatus,
      pendingCount: newPending,
      refreshId: newPending === 0 ? null : lastStatus.refreshId,
    };
  }
  return lastStatus;
};

// eslint-disable-next-line default-param-last
const holdings = (state = initialState, action) => {
  let id = [];
  let count = null;
  let slug = '';
  let data;
  let bracketOrders;
  let lastStatus = state.lastStatus;

  switch (action.type) {
    case TRADE.POSITIONS.SUCCESS: {
      slug = 'openPositions';
      id.push('open-positions');
      const positionsSnapshot = action.result.result;

      const openPositions = contractsObject();

      // Adding product and bracket order data
      // :TODO abstract
      forEach(position => {
        // set empty placeholder bracket orders obj
        position.bracket_orders = {
          stop_loss_order: {
            limit_price: null,
            stop_price: null,
            trail_amount: null,
          },
          take_profit_order: {
            limit_price: null,
            stop_price: null,
            trail_amount: null,
          },
        };
        // fill bracket orders obj with existing bracket orders
        if (state.bracketOrders[position.product_id]) {
          const bracketOrderObj = state.bracketOrders[position.product_id];
          if (bracketOrderObj.take_profit_order) {
            position.bracket_orders.take_profit_order = bracketOrderObj.take_profit_order;
          }
          if (bracketOrderObj.stop_loss_order) {
            position.bracket_orders.stop_loss_order = bracketOrderObj.stop_loss_order;
          }
        }

        const contractType = getContractType(
          path(['product', 'contract_type'], position)
        );
        openPositions[contractType]?.data.push(position);
      }, positionsSnapshot);

      openPositions.all = getAllContractsData(openPositions, 'openPositions');
      data = openPositions;
      count = data[state.selectedContractType].data.length;
      lastStatus = updateLastStatus(action, lastStatus);
      break;
    }
    case TRADE_CONSTANTS.OPEN_POSITIONS: {
      slug = 'openPositions';
      id.push('open-positions');
      data = action.result;

      // If the bracket order data was already there, fetch it.
      const contractTypes = keys(data);
      contractTypes.forEach(contract => {
        data[contract].data.forEach(position => {
          if (state.bracketOrders[position.product_id]) {
            const bracketOrderObj = state.bracketOrders[position.product_id];
            if (bracketOrderObj.take_profit_order) {
              position.bracket_orders.take_profit_order =
                bracketOrderObj.take_profit_order;
            }
            if (bracketOrderObj.stop_loss_order) {
              position.bracket_orders.stop_loss_order = bracketOrderObj.stop_loss_order;
            }
          }
        });
      });
      count = data[state.selectedContractType].data.length;
      break;
    }
    case TRADE.OPEN_ORDERS.SUCCESS: {
      const orders = action.result.body.result;
      slug = 'openOrders';
      id.push('open-orders');
      const filteredOpenOrder = filterOrdersFromApi(orders);
      count = filteredOpenOrder[state.selectedContractType].data.length;
      return {
        ...state,
        openOrders: filteredOpenOrder,
        lastStatus: updateLastStatus(action, lastStatus),
      };
    }
    case TRADE.OPEN_STOP_ORDERS.SUCCESS: {
      const orders = action.result.body.result;
      slug = 'openStopOrders';
      id.push('stop-orders');
      const filteredOpenStopOrder = filterOrdersFromApi(orders);
      count = filteredOpenStopOrder[state.selectedContractType].data.length;
      // Check bracket orders and update them accordingly.
      // Check for all open stop orders, if there is bracket orders present in state which does not comes in open stop orders, remove them from bracket orders

      // Extract all order IDs from open stop orders
      const openStopOrderIds = pipe(
        values,
        map(contractType => contractType.data),
        flatten,
        map(prop('id'))
      )(filteredOpenStopOrder);

      // Function to check if a bracket order exists in open stop orders and update it if needed
      const updateBracketOrder = (bracketOrder, orderType) => {
        if (path([orderType, 'id'], bracketOrder)) {
          // If the bracket order ID is not in open stop orders, reset it
          if (!includes(bracketOrder[orderType].id, openStopOrderIds)) {
            return {
              ...bracketOrder,
              [orderType]: initBracketOrderObj(),
            };
          }
        }
        return bracketOrder;
      };

      // Apply the update to all bracket orders using functional composition
      const bracketOrderPairs = pipe(
        toPairs,
        map(([productId, bracketOrder]) => [
          productId,
          pipe(
            order => updateBracketOrder(order, 'take_profit_order'),
            order => updateBracketOrder(order, 'stop_loss_order')
          )(bracketOrder),
        ])
      )(state.bracketOrders);

      // Convert pairs back to an object using native Object.fromEntries
      const updatedBracketOrders = Object.fromEntries(bracketOrderPairs);
      return {
        ...state,
        openStopOrders: filteredOpenStopOrder,
        bracketOrders: updatedBracketOrders,
        lastStatus: updateLastStatus(action, lastStatus),
      };
    }
    case TRADE_CONSTANTS.OPEN_ORDERS:
      slug = 'openOrders';
      id.push('open-orders');
      return getOrders(action.result, state, id, slug);

    case TRADE_CONSTANTS.OPEN_STOP_ORDERS:
      slug = 'openStopOrders';
      id.push('stop-orders');
      return getOrders(action.result, state, id, slug);
    case UNAUTHORIZED:
    case USER.LOGOUT.SUCCESS:
      id = ['open-positions', 'open-orders', 'stop-orders'];
      count = null;
      // console.log('DEBUG', { action, initialState, state });
      // returning initialState was having some position and orders inside.
      // todo:@suraj-kawale-au2 refactor holdings reducer.
      return {
        desktop: tabList,
        mobile: tabListMobile,
        openPositions: contractsObject(),
        openOrders: contractsObject(),
        openStopOrders: contractsObject(),
        bracketOrders: {},
        selectedContractType: 'all',
        holdingsFilterType: 'dropdown',
        mobileHoldingsContractType: 'all',
        loading: {
          openPositions: true,
          // Below are false as we never know whether we have orders or not
          openOrders: false,
          openStopOrders: false,
        },
      };
    case TRADE_CONSTANTS.CHANGE_CONTRACT_TYPE:
      id = ['open-positions', 'open-orders', 'stop-orders'];
      count = null;
      break;

    case TRADE_CONSTANTS.CHANGE_MOBILE_CONTRACT_TYPE: {
      const contract_type = action.payload;
      return {
        ...state,
        mobileHoldingsContractType: contract_type,
      };
    }

    case TRADE_CONSTANTS.CHANGE_HOLDINGS_CONTRACT_TYPE: {
      const contract_type = action.payload;
      return {
        ...state,
        selectedContractType: contract_type,
      };
    }
    case TRADE_CONSTANTS.CHANGE_HOLDINGS_FILTER_TYPE: {
      const filterType = action.payload;
      return {
        ...state,
        holdingsFilterType: filterType,
      };
    }
    case TRADE_CONSTANTS.UPDATE_OPEN_ORDERS:
      id = ['open-orders'];
      slug = 'openOrders';
      return updateOrderObj(action.result, state, id, slug);

    case TRADE_CONSTANTS.UPDATE_STOP_ORDERS:
      id = ['stop-orders'];
      slug = 'openStopOrders';
      return updateOrderObj(action.result, state, id, slug);
    case TRADE_CONSTANTS.DELETE_BRACKET_ORDER:
      data = action.result;
      bracketOrders = state.bracketOrders;

      bracketOrders[data.product_id][data.stop_order_type] = initBracketOrderObj();

      return getNewState(state, [data], bracketOrders, 'delete');

    case TRADE_CONSTANTS.UPDATE_POSITIONS:
      id = ['open-positions'];
      slug = 'openPositions';
      return updateOrderObj(action.result, state, id, slug);

    case TRADE_CONSTANTS.UPDATE_BRACKET_ORDER:
      data = action.result;
      bracketOrders = state.bracketOrders;
      if (!bracketOrders[data[0].product_id]) {
        bracketOrders[data[0].product_id] = {};
      }

      data.forEach(
        obj =>
          (bracketOrders[obj.product_id][obj.stop_order_type] = getBracketOrderObj(obj))
      );

      // If we already have positions data, update bracket orders
      return getNewState(state, data, bracketOrders, 'update');

    // (WEB-4710) - Clear openOrders || openStopOrders state on cancel all API success since delete socket update don't reach FE.
    case TRADE.CANCEL_ALL_ORDER.SUCCESS: {
      const { cancelLimitOrders, cancelStopOrders } = action?.params ?? {};
      return {
        ...state,
        ...(cancelLimitOrders === 'true' && { openOrders: contractsObject() }),
        ...(cancelStopOrders === 'true' && { openStopOrders: contractsObject() }),
      };
    }

    // (WEB-4710) - Remove order from open order || stop order state on cancel single API success as delete socket update don't reach FE.
    case TRADE.ORDER_CANCEL.SUCCESS: {
      data = action?.result?.result ?? {};
      const orderCategory = action?.options?.orderCategory ?? '';
      data.product = getProductByIDHelper(action.state, action.result.result.product_id);
      data.action = 'delete';
      id = [orderCategoryIdMap[orderCategory]];
      slug = orderCategorySlugMap[orderCategory] ?? '';
      if (!id || !slug) return noop;
      return updateOrderObj(data, state, id, slug);
    }

    case TRADE.POSITIONS.FAIL:
    case TRADE.OPEN_ORDERS.FAIL:
    case TRADE.OPEN_STOP_ORDERS.FAIL:
    case WALLET.BALANCES.SUCCESS:
    case WALLET.BALANCES.FAIL:
    case TRADE_CONSTANTS.POSITIONS_FAIL_ABORTED:
    case TRADE_CONSTANTS.OPEN_ORDERS_FAIL_ABORTED:
    case TRADE_CONSTANTS.OPEN_STOP_ORDERS_FAIL_ABORTED:
    case BALANCES_FAIL_ABORTED: {
      return {
        ...state,
        lastStatus: updateLastStatus(action, lastStatus),
      };
    }

    case DISPATCH_HOLDINGS_API_START: {
      return {
        ...state,
        lastStatus: {
          isUserTriggered: action.payload.isUserTriggered,
          // positions, openOrders, openStopOrders, balances
          pendingCount: 4,
          refreshId: action.meta.refreshId,
        },
      };
    }

    default:
      return state;
  }

  const evolveState = getEvolveState(state, id, count);

  return updateStateObj(slug, state, data, { ...evolveState, lastStatus });
};

export default holdings;
